import { render } from "./ExtraInfo.vue?vue&type=template&id=61e9982a&scoped=true"
import script from "./ExtraInfo.vue?vue&type=script&lang=js"
export * from "./ExtraInfo.vue?vue&type=script&lang=js"

import "@/assets/css/newdesign.scss?vue&type=style&index=0&id=61e9982a&lang=scss&scoped=true"
import "./ExtraInfo.vue?vue&type=style&index=1&id=61e9982a&scoped=true&lang=css"

import exportComponent from "/home/runner/work/treedots/treedots/apps/frontend-b2b/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-61e9982a"]])

export default __exports__